export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  ADD_MESSAGE_TO_NOTE: 'ADD_MESSAGE_TO_NOTE',
  EMOJI_PICKER_OPENED: 'EMOJI_PICKER_OPENED',
  MESSAGE_INTERACTION_OPENED: 'MESSAGE_INTERACTION_OPENED',
  OPEN_MESSAGE_INFO: 'OPEN_MESSAGE_INFO',
  ACELERES_EQUIPE_ONLINE_REFRESH: 'ACELERES_EQUIPE_ONLINE_REFRESH',
  ACELERES_CONVERSATION_STARTED: 'ACELERES_CONVERSATION_STARTED',
  ACELERES_CARTEIRIZACAO_REQUEST_UPDATED:
    'ACELERES_CARTEIRIZACAO_REQUEST_UPDATED',
  ACELERES_CONVERSATION_PREVIEW_RECONCILED:
    'ACELERES_CONVERSATION_PREVIEW_RECONCILED',
};
